import { createFileRoute, useSearch } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { AssetsCanvas } from '@/features/app-shell/canvases/assets-canvas'
import type { LibraryCategory } from '@/shared/api/app-types'

type AppAssetsSearch = {
  tab?: LibraryCategory
}

const VALID_TABS: LibraryCategory[] = ['image', 'video', 'audio', 'font', 'subtitle']

export const Route = createFileRoute('/app/assets')({
  validateSearch: (search: Record<string, unknown>): AppAssetsSearch => ({
    tab: VALID_TABS.includes(search.tab as LibraryCategory)
      ? (search.tab as LibraryCategory)
      : undefined,
  }),
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppAssetsPage,
})

function AppAssetsPage() {
  const search = useSearch({ from: '/app/assets' })

  return (
    <AppShell activePath="/app/assets">
      <AssetsCanvas initialCategory={search.tab ?? 'all'} />
    </AppShell>
  )
}
